import React from "react";
import _ from "lodash";
import ModalWrapper from "components/common/ModalWrapper";
import ClickToCopyWrapper from "components/common/ClickToCopyWrapper";
import HighchartWrapper from "components/common/HighchartWrapper";
import Checkbox from "components/common/Checkbox";
import { DEMAND_TYPES, UNFILLED } from "constants/DemandType";
import {
  DEMAND_TYPE_COLORS,
  DEMAND_TYPE_COLORS_CVD,
  DEMAND_GROUPS_COLORS,
  DEMAND_GROUPS_COLORS_CVD,
  REV_LIFT_COLOR,
  REV_LIFT_COLOR_CVD,
} from "components/inventory-rev/DataHelper";
import {
  METRIC,
  GROUP,
  dpGroupList,
  getDemandTypeByView,
  VIEW,
} from "./DataHelper";

import { FiCompass, FiRefreshCw } from "react-icons/fi";
import {
  getChartOption,
  getPieChartOption,
  getLineChartOption,
  getBarChartOption,
} from "./DataHelper";

class DemandTypeColorSetButton extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isOpenModal: false,
    };
  }

  render() {
    const { isOpenModal } = this.state;
    const { isCVDVision, networkInfo } = this.props;

    return (
      <>
        <div
          className="cursor-pointer text-blue-600 hover:text-blue-800"
          onClick={() => this.setState({ isOpenModal: true })}
        >
          <FiCompass></FiCompass>
        </div>
        {isOpenModal && (
          <DemandTypeColorSetModal
            isCVDVision={isCVDVision}
            networkInfo={networkInfo}
            onClose={() => this.setState({ isOpenModal: false })}
          />
        )}
      </>
    );
  }
}

const MOCK_DATA = [
  25652462, 27622321, 23992315, 27231710, 24544599, 28146414, 26428058,
  26229944,
];

const MOCK_DATE_LIST = [
  "2025-11-19",
  "2025-11-20",
  "2025-11-21",
  "2025-11-22",
  "2025-11-23",
  "2025-11-24",
  "2025-11-25",
  "2025-11-26",
];

const REV_LIFT = "Rev Lift";

const COLOR_ITEM_WIDTH = "calc(16.6% - 0.4rem)";

class DemandTypeColorSetModal extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      colorSet: new Map(DEMAND_TYPE_COLORS),
      colorSetCVD: new Map(DEMAND_TYPE_COLORS_CVD),

      groupColorSet: new Map(DEMAND_GROUPS_COLORS),
      groupColorSetCVD: new Map(DEMAND_GROUPS_COLORS_CVD),

      liftColorSet: new Map([[REV_LIFT, REV_LIFT_COLOR]]),
      liftColorSetCVD: new Map([[REV_LIFT, REV_LIFT_COLOR_CVD]]),

      pieOptions: null,
      lineOptions: null,
      barOptions: null,
      groupPieOptions: null,
      groupBarOptions: null,

      isCVDVision: this.props.isCVDVision,
    };

    this.handleCopyColorSet = this.handleCopyColorSet.bind(this);
    this.handleChangeColor = this.handleChangeColor.bind(this);
    this.handleResetColorSet = this.handleResetColorSet.bind(this);
    this.handleProcessOptions = this.handleProcessOptions.bind(this);
  }

  componentDidMount() {
    this.handleProcessOptions();
  }

  handleCopyColorSet(isCVD = false) {
    const {
      colorSet,
      colorSetCVD,
      groupColorSet,
      groupColorSetCVD,
      liftColorSet,
      liftColorSetCVD,
    } = this.state;

    const colorObj = {
      demandTypes: isCVD ? colorSetCVD : colorSet,
      groups: isCVD ? groupColorSetCVD : groupColorSet,
      revLift: isCVD ? liftColorSetCVD : liftColorSet,
    };

    return _.keys(colorObj)
      .map((key) => {
        return `${key}: ${_.map([...colorObj[key]], ([, color]) => color).join(
          ","
        )}`;
      })
      .join("\n");
  }

  handleChangeColor(colorSet, demandType, newColor) {
    const { isCVDVision } = this.state;
    const tempSet = new Map(this.state[colorSet]);
    tempSet.set(demandType, newColor);
    this.setState({ [colorSet]: tempSet }, () => {
      if (isCVDVision && colorSet.includes("CVD")) {
        this.handleProcessOptions();
      } else if (!isCVDVision && !colorSet.includes("CVD")) {
        this.handleProcessOptions();
      }
    });
  }

  handleProcessOptions() {
    this.setState({ pieOptions: null, lineOptions: null, barOptions: null });

    const { networkInfo } = this.props;
    const {
      colorSet,
      colorSetCVD,
      isCVDVision,
      groupColorSet,
      groupColorSetCVD,
      liftColorSet,
      liftColorSetCVD,
    } = this.state;

    const liftData = _.map(MOCK_DATE_LIST, (date, idx) => ({
      date,
      lift: 0.2 + idx * 0.07,
    }));

    const data = _.zipObject(
      _.values(DEMAND_TYPES),
      new Array(_.values(DEMAND_TYPES).length).fill({
        o_imp: MOCK_DATA,
        bm_imp: MOCK_DATA,
      })
    );

    const groupedData = _.zipObject(
      _.values(dpGroupList),
      new Array(_.values(dpGroupList).length).fill({
        o_imp: MOCK_DATA,
        bm_imp: MOCK_DATA,
      })
    );

    const params = {
      data,
      liftData,
      list: [..._.values(DEMAND_TYPES), UNFILLED],
      dateList: MOCK_DATE_LIST,
      colorSet: isCVDVision ? colorSetCVD : colorSet,
      colorLift: isCVDVision
        ? liftColorSetCVD.get(REV_LIFT)
        : liftColorSet.get(REV_LIFT),
      metricOption: { label: "MOCK" },
      demandTypes: _.values(DEMAND_TYPES),
      metric: METRIC.IMPRESSIONS,
      group: GROUP.BM,
    };

    this.setState({
      pieOptions: getPieChartOption(params),
      lineOptions: getLineChartOption({
        ...params,
        data: _.mapValues(params.data, (obj, key) => {
          return _.mapValues(obj, (arr) => {
            const idx = _.values(DEMAND_TYPES).indexOf(key);
            return arr.map((v) => v + idx * 2000000);
          });
        }),
      }),
      barOptions: getChartOption(params),
      groupPieOptions: getPieChartOption({
        ...params,
        data: groupedData,
        list: dpGroupList,
        colorSet: isCVDVision ? groupColorSetCVD : groupColorSet,
      }),
      groupBarOptions: [
        getBarChartOption({
          ...params,
          list: getDemandTypeByView({ view: VIEW.BILLABLE, networkInfo }),
        }),
        getBarChartOption({
          ...params,
          list: getDemandTypeByView({ view: VIEW.GUARANTEED, networkInfo }),
        }),
        getBarChartOption({
          ...params,
          list: getDemandTypeByView({ view: VIEW.NON_BILLABLE, networkInfo }),
        }),
      ],
    });
  }

  handleResetColorSet(isCVD = false) {
    const { isCVDVision } = this.state;
    const data = isCVD
      ? {
          colorSetCVD: new Map(DEMAND_TYPE_COLORS_CVD),
          groupColorSetCVD: new Map(DEMAND_GROUPS_COLORS_CVD),
          liftColorSetCVD: new Map([[REV_LIFT, REV_LIFT_COLOR_CVD]]),
        }
      : {
          colorSet: new Map(DEMAND_TYPE_COLORS),
          groupColorSet: new Map(DEMAND_GROUPS_COLORS),
          liftColorSet: new Map([[REV_LIFT, REV_LIFT_COLOR]]),
        };

    this.setState(data, () => {
      if (isCVDVision === isCVD) {
        this.handleProcessOptions();
      }
    });
  }

  render() {
    const { onClose } = this.props;
    const {
      colorSet,
      colorSetCVD,
      groupColorSet,
      groupColorSetCVD,
      liftColorSet,
      liftColorSetCVD,
      isCVDVision,

      pieOptions,
      lineOptions,
      barOptions,
      groupPieOptions,
      groupBarOptions,
    } = this.state;

    return (
      <ModalWrapper
        isOpen={true}
        title="Demand Type Color Set"
        showCloseFooter={true}
        customOverlayStyle={{ zIndex: 100 }}
        handleClose={onClose}
        width="80%"
      >
        <div>
          <div className="flex items-center">
            <label>
              <Checkbox
                label="General Vision"
                isChecked={!isCVDVision}
                onChange={() =>
                  this.setState({ isCVDVision: !isCVDVision }, () => {
                    this.handleProcessOptions();
                  })
                }
              />
              <span className="ml-2 mr-1 cursor-pointer text-gray-800">
                General Vision
              </span>
            </label>
            <ClickToCopyWrapper
              copyText={this.handleCopyColorSet(false)}
            ></ClickToCopyWrapper>
            <div className="text-sm text-gray-600">
              Click to copy color set as list
            </div>
            <div
              className="ml-auto flex cursor-pointer items-center gap-1 text-gray-600 hover:text-blue-600"
              onClick={() => this.handleResetColorSet(false)}
            >
              <FiRefreshCw />
              Reset as Default
            </div>
          </div>

          <div className="flex flex-wrap gap-2 text-sm">
            {[...colorSet].map(([key, color]) => (
              <div key={`colorSet-${key}`} style={{ width: COLOR_ITEM_WIDTH }}>
                <ColorItem
                  color={color}
                  label={key}
                  onChange={(e) => {
                    this.handleChangeColor("colorSet", key, e.target.value);
                  }}
                ></ColorItem>
              </div>
            ))}
          </div>

          <div className="mt-2 flex flex-wrap gap-2 text-sm">
            {[...groupColorSet].map(([key, color]) => (
              <div
                key={`groupColorSet-${key}`}
                style={{ width: COLOR_ITEM_WIDTH }}
              >
                <ColorItem
                  color={color}
                  label={key}
                  onChange={(e) => {
                    this.handleChangeColor(
                      "groupColorSet",
                      key,
                      e.target.value
                    );
                  }}
                ></ColorItem>
              </div>
            ))}
            <div className="border border-gray-400"></div>
            {[...liftColorSet].map(([key, color]) => (
              <div
                key={`liftColorSet-${key}`}
                style={{ width: COLOR_ITEM_WIDTH }}
              >
                <ColorItem
                  color={color}
                  label={key}
                  onChange={(e) => {
                    this.handleChangeColor("liftColorSet", key, e.target.value);
                  }}
                ></ColorItem>
              </div>
            ))}
          </div>

          <div className="mt-2 flex items-center">
            <label>
              <Checkbox
                label="CVD Vision"
                isChecked={isCVDVision}
                onChange={() =>
                  this.setState({ isCVDVision: !isCVDVision }, () => {
                    this.handleProcessOptions();
                  })
                }
              />
              <span className="ml-2 mr-1 cursor-pointer text-gray-800">
                CVD Vision
              </span>
            </label>

            <ClickToCopyWrapper
              copyText={this.handleCopyColorSet(true)}
            ></ClickToCopyWrapper>
            <div className="text-sm text-gray-600">
              Click to copy color set as list
            </div>
            <div
              className="ml-auto flex cursor-pointer items-center gap-1 text-gray-600 hover:text-blue-600"
              onClick={() => this.handleResetColorSet(true)}
            >
              <FiRefreshCw />
              Reset as Default
            </div>
          </div>

          <div className="flex flex-wrap gap-2 text-sm">
            {[...colorSetCVD].map(([key, color]) => (
              <div
                key={`colorSetCVD-${key}`}
                style={{ width: COLOR_ITEM_WIDTH }}
              >
                <ColorItem
                  color={color}
                  label={key}
                  isCVD={true}
                  onChange={(e) => {
                    this.handleChangeColor("colorSetCVD", key, e.target.value);
                  }}
                ></ColorItem>
              </div>
            ))}
          </div>

          <div className="border-b mt-2 flex flex-wrap gap-2 border-gray-400 pb-2 text-sm">
            {[...groupColorSetCVD].map(([key, color]) => (
              <div
                key={`groupColorSetCVD-${key}`}
                style={{ width: COLOR_ITEM_WIDTH }}
              >
                <ColorItem
                  color={color}
                  label={key}
                  isCVD={true}
                  onChange={(e) => {
                    this.handleChangeColor(
                      "groupColorSetCVD",
                      key,
                      e.target.value
                    );
                  }}
                ></ColorItem>
              </div>
            ))}
            <div className="border border-gray-400"></div>
            {[...liftColorSetCVD].map(([key, color]) => (
              <div
                key={`liftColorSetCVD-${key}`}
                style={{ width: COLOR_ITEM_WIDTH }}
              >
                <ColorItem
                  color={color}
                  label={key}
                  isCVD={true}
                  onChange={(e) => {
                    this.handleChangeColor(
                      "liftColorSetCVD",
                      key,
                      e.target.value
                    );
                  }}
                ></ColorItem>
              </div>
            ))}
          </div>

          <div className="overflow-y-auto" style={{ height: "400px" }}>
            <div className="flex">
              <div className="w-1/4">
                {groupPieOptions && (
                  <HighchartWrapper
                    options={groupPieOptions}
                  ></HighchartWrapper>
                )}
              </div>

              {groupBarOptions &&
                groupBarOptions.map((option, idx) => (
                  <div className="w-1/4" key={`groupBarOption-${idx}`}>
                    <HighchartWrapper options={option}></HighchartWrapper>
                  </div>
                ))}
            </div>
            <div className="flex">
              <div className="w-1/3">
                {pieOptions && (
                  <HighchartWrapper options={pieOptions}></HighchartWrapper>
                )}
              </div>
              <div className="w-2/3">
                {lineOptions && (
                  <HighchartWrapper options={lineOptions}></HighchartWrapper>
                )}
              </div>
            </div>
            <div>
              {barOptions && (
                <HighchartWrapper options={barOptions}></HighchartWrapper>
              )}
            </div>
          </div>
        </div>
      </ModalWrapper>
    );
  }
}

class ColorItem extends React.PureComponent {
  render() {
    const { color, label, onChange, isCVD = false } = this.props;
    return (
      <div className="border rounded flex items-center border-gray-400 px-2 py-1">
        <input
          className="h-5 w-5"
          type="color"
          value={color}
          onChange={onChange}
        />
        <ClickToCopyWrapper
          buttonText={label}
          copyText={`${isCVD ? "[CVD] " : ""}${label}: ${color}`}
          tooltipMessage="Click to copy color code"
          iconType=""
        ></ClickToCopyWrapper>
        <input
          type="text"
          value={color}
          onChange={onChange}
          className="ml-auto pl-1"
          style={{ width: "4.5rem" }}
        />
      </div>
    );
  }
}

export default DemandTypeColorSetButton;
